export default __webpack_public_path__ + "static/media/image1.9d838322.svg";